






import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SubmitButton extends Vue {
  @Prop(Boolean)
  readonly show?: boolean
}
